'use client'
import NavigateRightIcon from '@/app/icons/navigate-right'
import { AdDecision } from '@/app/util/ads-endpoint'
import Attribution from '@/components/attribution'
import { getGifWidth } from '@giphy/js-util'
import { Gif, GifOverlayProps } from '@giphy/react-components'

const GridOverlay = ({ gif, carouselData }: GifOverlayProps & { carouselData: AdDecision }) => {
    return (
        <div className="absolute inset-0">
            <Attribution user={gif.user} className="absolute bottom-2 left-2" noLink />
            {carouselData?.cta_url && (
                <div
                    className="text-giphyWhite bg-giphyBlack absolute bottom-2 right-2 flex h-[50px] items-center justify-center gap-2 rounded-md bg-opacity-50 px-5 font-bold hover:bg-opacity-80"
                    onClick={(e) => {
                        e.preventDefault()
                        e.stopPropagation()
                        window.open(carouselData.cta_url, '_blank')
                    }}
                >
                    {carouselData.cta_text} <NavigateRightIcon className="fill-giphyWhite size-3" />
                </div>
            )}
        </div>
    )
}
export const MainGif = ({ data, width }: { data: AdDecision; width: number; height?: number }) => {
    const { gif } = data
    const aspectRatio = gif.images.original.width / gif.images.original.height
    return (
        <Gif
            gif={gif}
            width={width}
            percentWidth="100%"
            overlay={(props) => <GridOverlay {...props} carouselData={data} />}
            style={{ aspectRatio }}
            lazyLoad={false}
        />
    )
}

export const CarouselGif = ({ data, height }: { data: AdDecision; height: number }) => {
    const { gif, impression_url, click_url } = data
    return (
        <Gif
            gif={gif}
            key={gif.id}
            height={height}
            width={getGifWidth(gif, height)}
            className="shrink-0"
            hideAttribution
            onGifClick={() => {
                window.open(click_url, '_blank')
            }}
            onGifSeen={() => {
                try {
                    if (impression_url) fetch(impression_url)
                } catch (_e) {}
            }}
        />
    )
}
